module.exports = __webpack_public_path__ + "discord_logo.3dbd41298e41d4223161a86ef0888265.png";